import React from "react";
import { Link } from "react-router-dom";
import { Baseless } from "../../components/Base";

export const SupportScreen = () => {
	return (
		<Baseless
			title={""}
			icon={"dashboard_"}
            style={{top: 0}}
		>
			<>
				<div className="support-bg-container" style={{marginTop: 0}}>
					<h2>Get In Touch</h2>
					<p>We are here to help you get started with Payvessel.</p>
					<p>
						If you have any questions, feel free to start a live
						chat conversation or contact us.
					</p>
				</div>

				<div className="support-option">
					<div className="support-card-div" style={{width: "80%"}}>
						<div className="support-single">
							<div className="content">
								<div className="icon">
									<i className="fa fa-add"></i>
								</div>
								<h2> JOIN PAYVESSEL FAMILY</h2>
								<p>
									Get latest information on payvessel whatsapp
									channel
								</p>
							</div>

							<div className="button">
								<Link
									to="https://whatsapp.com/channel/0029Va9FcRzElagxeiWsWR3c"
									className="button-link"
								>
									Join Now
								</Link>
							</div>
						</div>

						<div className="support-single">
							<div className="content">
								<div className="icon">
									<i className="far fa-comment"></i>
								</div>
								<h2> GET IN TOUCH</h2>
								<p>please reach out to our support team</p>
							</div>

							<div className="button">
								<Link
									to="mailto:support@payvessel.com"
									className="button-link"
								>
									Send Email
								</Link>
							</div>
						</div>
					</div>
				</div>
			</>
		</Baseless>
	);
};
